import Icon from './chat.svg?react'
import { createIcon } from './factory'

export const Chat = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
